<template>
  <div class="page-item">
    <MdScroll id="artice" class="wrap" :url="url" :filterData="filterData" @getList="getList">
      <div class="item" v-for="item in list" :key="item.Id">
        <ArticleBlock :info="item"></ArticleBlock>
      </div>
      <EmptyPosition v-show="!list.length" type="article"></EmptyPosition>
    </MdScroll>
  </div>
</template>

<script>
import ArticleBlock from '@/components/article/articleBlock'
import MdScroll from '@/components/mdScroll/mdScroll'
import EmptyPosition from '@/components/common/emptyPosition'
import { Cms } from '@/api'

export default {
  name: "artice",
  components: { MdScroll, ArticleBlock, EmptyPosition },
  data() {
    return {
      list: [],
      url: Cms.Search,
      filterData: {
        Type: 1,
        Status: 2,
        UserId: this.$mdUtils.getUserInfo('Id'),
        PageIndex: 1,
        PageSize: 10
      }
    }
  },
  methods: {
    getList(list) {
      this.list = list
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  padding: 0 20px;
}
</style>

